import React from 'react';
import { useTestPipelineDrawerContext } from 'app/pipeline-details/StatusItem/TestPipelineDrawerContextProvider';
import { usePipelinePageContext } from 'app/pipeline-details/PipelinePageContextProvider';
import SendEventModalLauncher from 'app/shared/components/testing-suite/SendEventModalLauncher';
import ServerResponseOutput from 'app/shared/components/testing-suite/ServerResponseOutput';
import { useTrackPage } from 'api';

export default function ServerResponseTab() {
  useTrackPage('test_pipeline_server_response_tab_viewed');

  const {
    state: { chainState, selectedPipelineIntegration },
  } = useTestPipelineDrawerContext();
  const {
    pipeline: { cluster },
  } = usePipelinePageContext();
  const { sendEventConfirmed, onConfirmSendEvent, loading, data } = chainState.serverResponse;

  if (!sendEventConfirmed) {
    return (
      <SendEventModalLauncher
        onConfirm={onConfirmSendEvent}
        integrationName={selectedPipelineIntegration.integration.name}
        clusterName={cluster.name}
      />
    );
  }

  return (
    <ServerResponseOutput
      loading={loading}
      data={data}
      trackingEventName="test_pipeline_server_response_tab_output_viewed"
    />
  );
}
